var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"mr-1",attrs:{"href":"#"},on:{"click":_vm.showPopup}},[_c('font-awesome-icon',{attrs:{"icon":['fa', 'info-circle']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }